import React, { useEffect } from 'react';
import useFormPredertermineStore from './FormConditionStores/useFormPredertermineStore';
import ItemStatementCondition from './FormConditionComponents/ItemStatementPredertermine';

function FormConditional({ autoAnswer, availablePlaceholders }) {
  useEffect(() => {
    if (autoAnswer && typeof autoAnswer === 'object') {
      useFormPredertermineStore.getState().setStatement(autoAnswer);
      useFormPredertermineStore.getState().setFormConditional(autoAnswer);
    } else {
      useFormPredertermineStore.getState().initialiseEmpty();
    }
  }, []);

  const { Condition } = useFormPredertermineStore((s) => s.Statement.Statement.content);
  const AnswerList = useFormPredertermineStore((s) => s.AnswerList);

  return (
    <div
      style={{
        boxShadow: '0px 2px 4px var(--mui-palette-action-focus)',
        padding: '15px 15px 30px',
        margin: '15px 0',
      }}
    >
      {Condition &&
        Condition.map((condition, index) => (
          <ItemStatementCondition
            condition={condition}
            indexStatement={index}
            key={index}
            AnswerList={AnswerList[index]}
            availablePlaceholders={availablePlaceholders}
          />
        ))}
    </div>
  );
}
export default FormConditional;
